import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Button } from 'components';
import { GeneralService, ServiceService } from 'services';
import { CheckWhiteIcon } from 'assets/icons';
import CallingServices from './calling/calling-services';
import { LawyerServiceArea } from 'types';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
  plan_user: any;
}

class Services extends React.Component<Props> {
  state = {
    form: {
      service_id: Constants.SERVICES.PREPARATION,
    },
    areas: [] as LawyerServiceArea[],
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Servicios',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
  }

  changeService = (service_id: number) => {
    this.setState({
      form: {
        ...this.state.form,
        service_id,
      },
    });
  };

  load = async (service_id: number | null = this.state.form.service_id) => {
    if (service_id) {
      await this.setState({
        form: {
          ...this.state.form,
          service_id,
        },
      });
    }

    const res: any = await ServiceService.get({
      service_id,
      user_id: this.props.user?.id,
    });

    let areas: LawyerServiceArea[] = res.areas || [];

    for (let i = 0; i < areas.length; i++) {
      for (let j = 0; j < areas[i].documents.length; j++) {
        const item = (areas[i].documents[j] as any).user_price;

        areas[i].documents[j].user_price = '';

        if (item) {
          areas[i].documents[j].active = true;
          areas[i].documents[j].user_price = item.price || '';
        }
      }
    }

    this.setState({
      areas: res.areas || [],
    });
  };

  loadAreas = () => {
    this.setState(
      {
        form: {
          ...this.state.form,
          service_id: Constants.SERVICES.CHAT,
        },
      },
      async () => {
        const res: any = await GeneralService.getSelects({
          user_id: this.props.user?.id,
          lawyer_areas: true,
        });

        this.setState({
          areas: res.areas || [],
        });
      },
    );
  };

  changeDocumentPrice = (e: any, area_index: number, document_index: number) => {
    let areas = [...this.state.areas];
    (areas[area_index].documents[document_index] as any)[e.target.name] = e.target.value;
    this.setState({ areas });
  };

  setActiveDocument = (area_index: number, document_index: number) => {
    let areas = [...this.state.areas];
    areas[area_index].documents[document_index].active =
      !areas[area_index].documents[document_index].active;
    this.setState({ areas });
  };

  setActiveChat = (area_index: number) => {
    let areas = [...this.state.areas];
    areas[area_index].with_chat = !areas[area_index].with_chat;
    this.setState({ areas });
  };

  setAllActiveChat = () => {
    let areas = [...this.state.areas];
    const all_active = areas.filter((i) => i.with_chat).length == areas.length;
    for (let i = 0; i < areas.length; i++) {
      areas[i].with_chat = !all_active;
    }
    this.setState({ areas });
  };

  setAllActive = (area_index: number) => {
    let areas = [...this.state.areas];
    const all_active =
      areas[area_index].documents.filter((i) => i.active).length ==
      areas[area_index].documents.length;
    for (let i = 0; i < areas[area_index].documents.length; i++) {
      areas[area_index].documents[i].active = !all_active;
    }
    this.setState({ areas });
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (
      this.state.form.service_id == Constants.SERVICES.PREPARATION ||
      this.state.form.service_id == Constants.SERVICES.REVISION
    ) {
      for (let i = 0; i < this.state.areas.length; i++) {
        const area = this.state.areas[i];
        const items_pending = area.documents.filter((i) => !i.user_price && i.active).length;

        if (items_pending > 0) {
          Globals.showError('Por favor, ingrese el costo de todos los documentos');
          return;
        }
      }
    }

    let documents: any[] = [];

    for (let i = 0; i < this.state.areas.length; i++) {
      documents = [
        ...documents,
        ...this.state.areas[i].documents
          .filter((i) => i.active)
          .map((i) => {
            const price =
              this.state.form.service_id == Constants.SERVICES.PREPARATION
                ? i?.user_price
                : (i?.price as any)?.price;

            return {
              document_id: i.id,
              user_price: i?.user_price,
            };
          }),
      ];
    }

    await ServiceService.save({
      user_id: this.props.user?.id,
      ...this.state.form,
      prices: JSON.stringify(documents),
    });
    Globals.showSuccess('Se ha modificado el servicio correctamente');
  };

  submitChat = async (e: any) => {
    e.preventDefault();
    const { areas } = this.state;
    const user = this.props.user;

    const data = {
      user_id: user?.id,
      areas: areas.map((i) => ({
        area_id: i.area_id,
        with_chat: i.with_chat,
      })),
    };

    await ServiceService.saveChat(data);
    Globals.showSuccess('Se ha modificado el servicio correctamente');
  };

  render() {
    let title = '';
    let subtitle = '';

    const { form } = this.state;
    const { service_id } = form;
    const isInternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
    const hasMembership = this.props.plan_user != null;

    // Abogado externo sin membresía: mostrar gate en lugar del contenido.
    // Consistente con el patrón de signatures.tsx y calls.tsx.
    if (!isInternal && !hasMembership) {
      return (
        <div id='lawyer-services'>
          <div className='container-white'>
            <div className='container-no-membership'>
              <p>Para acceder a la configuración de servicios necesita una membresía activa.</p>
            </div>
          </div>
        </div>
      );
    }

    switch (service_id) {
      case Constants.SERVICES.PREPARATION:
        title = 'Elaboración de documentos';
        subtitle = 'Seleccione en el listado los documentos que desea participar como elaborador.';
        break;

      case Constants.SERVICES.REVISION:
        title = 'Revisión de documentos';
        subtitle = 'Seleccione en el listado los documentos que desea participar como revisor.';
        break;

      case Constants.SERVICES.CHAT:
        title = 'Configurar chat';
        subtitle = 'Seleccione los tipos de derecho a atender mediante chat';
    }

    return (
      <div id='lawyer-services'>
        <div className='row row-tabs'>
          <div className='col-md-3'>
            <button
              className={`btn ${service_id == Constants.SERVICES.PREPARATION ? 'active' : 'inactive'}`}
              onClick={() => this.load(Constants.SERVICES.PREPARATION)}
            >
              Elaboración de documentos
            </button>
          </div>
          <div className='col-md-3'>
            <button
              className={`btn ${service_id == Constants.SERVICES.REVISION ? 'active' : 'inactive'}`}
              onClick={() => this.load(Constants.SERVICES.REVISION)}
            >
              Revisión de documentos
            </button>
          </div>
          {isInternal && (
            <div className='col-md-3'>
              <button
                className={`btn ${service_id == Constants.SERVICES.CALL ? 'active' : 'inactive'}`}
                onClick={() => this.changeService(Constants.SERVICES.CALL)}
              >
                Llamadas telefónicas
              </button>
            </div>
          )}
          {isInternal && (
            <div className='col-md-3'>
              <button
                className={`btn ${service_id == Constants.SERVICES.CHAT ? 'active' : 'inactive'}`}
                onClick={() => this.loadAreas()}
              >
                Configuración de chat
              </button>
            </div>
          )}
        </div>

        <div className='container-white'>
          <h3>{title}</h3>
          <p className='subtitle'>{subtitle}</p>
          {(service_id === Constants.SERVICES.PREPARATION ||
            service_id === Constants.SERVICES.REVISION) &&
            this.state.areas.map((item, index) => {
              const all_active =
                item?.documents?.filter((i) => i.active).length == item?.documents?.length;

              return (
                <div className='container-area' key={item.id}>
                  <div className='container-check' onClick={() => this.setAllActive(index)}>
                    <div className={`check ${all_active ? 'active' : ''}`}>
                      {all_active && <img src={CheckWhiteIcon} />}
                    </div>
                    <p className='area-title'>
                      {item.name}
                      {(item as any).is_specialty && (
                        <span className='badge-specialty'>Tu especialidad</span>
                      )}
                    </p>
                  </div>
                  <div className='row'>
                    <div className='col-8'></div>
                    <div className='col-4 text-center'>
                      <label>Costo ($)</label>
                    </div>
                  </div>
                  {item?.documents?.map((_document, _index) => (
                    <div className='row' key={_document.id}>
                      <div className='col-8'>
                        <div
                          className='container-check document'
                          onClick={() => this.setActiveDocument(index, _index)}
                        >
                          <div className={`check ${_document.active ? 'active' : ''}`}>
                            {_document.active && <img src={CheckWhiteIcon} />}
                          </div>
                          <p className='document-name'>{_document.name}</p>
                        </div>
                      </div>
                      <div className='col-4 text-center'>
                        <Input
                          type='decimal'
                          color='white'
                          value={_document.user_price}
                          placeholder='0'
                          name='user_price'
                          onChange={(e: any) => this.changeDocumentPrice(e, index, _index)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}

          {service_id === Constants.SERVICES.CHAT && (
            <>
              {this.state.areas.length > 0 && (
                <div className='container-area'>
                  <div
                    className='container-check'
                    onClick={() => this.setAllActiveChat()}
                    style={{ marginBottom: 30 }}
                  >
                    <div
                      className={`check ${
                        this.state.areas.filter((i) => i.with_chat).length ==
                        this.state.areas.length
                          ? 'active'
                          : ''
                      }`}
                    >
                      {this.state.areas.filter((i) => i.with_chat).length ==
                        this.state.areas.length && <img src={CheckWhiteIcon} />}
                    </div>
                    <p className='area-title' style={{ fontWeight: 'bold' }}>
                      Todos
                    </p>
                  </div>
                </div>
              )}
              {this.state.areas.map((item, index) => {
                const isActive = item?.with_chat;
                return (
                  <div className='container-area' key={item.id}>
                    <div className='container-check' onClick={() => this.setActiveChat(index)}>
                      <div className={`check ${isActive ? 'active' : ''}`}>
                        {isActive && <img src={CheckWhiteIcon} />}
                      </div>
                      <p className='area-title'>{item.area?.name}</p>
                    </div>
                  </div>
                );
              })}
              <div className='text-center'>
                <Button type='submit' onClick={(e: any) => this.submitChat(e)}>
                  Guardar
                </Button>
              </div>
            </>
          )}

          {service_id === Constants.SERVICES.CALL && (
            // @ts-ignore
            <CallingServices />
          )}

          {(service_id === Constants.SERVICES.PREPARATION ||
            service_id === Constants.SERVICES.REVISION) && (
            <div className='text-center'>
              <Button type='submit' onClick={(e: any) => this.submit(e)}>
                Guardar
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
    plan_user: state.plan_user,
  };
})(Services);
